import { createSlice } from '@reduxjs/toolkit';
import { TaxExemptionTeamMember } from '@dill/dill-shared';
import {
  getSupplierTaxExemptionTeamExtraReducer,
  createTaxExemptionTeamMemberExtraReducer,
  updateTaxExemptionTeamMemberExtraReducer,
  deleteTaxExemptionTeamMemberExtraReducer,
} from '../reducers/supplierAdditionalDetailsReducers';

export interface TaxExemptionTeamInitialState {
  loadingList: string[];
  error: string | null;
  taxExemptionTeam: TaxExemptionTeamMember[];
}

const initialState: TaxExemptionTeamInitialState = {
  loadingList: [],
  error: null,
  taxExemptionTeam: [],
};

export const taxExemptionTeamSlice = createSlice({
  name: 'taxExemptionTeam',
  initialState,
  reducers: {
    resetTaxExemptionTeamRootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierTaxExemptionTeamExtraReducer(builder);
    createTaxExemptionTeamMemberExtraReducer(builder);
    updateTaxExemptionTeamMemberExtraReducer(builder);
    deleteTaxExemptionTeamMemberExtraReducer(builder);
  },
});

export const { resetTaxExemptionTeamRootState } = taxExemptionTeamSlice.actions;
